// You can write more code here

/* START OF COMPILED CODE */

import BaseScene from "../core/scenes/BaseScene";
import BtnAudio from "../core/prefabs/BtnAudio";
import UIPositionContainer from "../core/components/UIPositionContainer";
import BtnPlay from "../core/prefabs/BtnPlay";
/* START-USER-IMPORTS */
import assetPack from '../../../static/assets/asset-pack-title.json';
import { app } from '../core/App';
import UIButton from '../core/components/UIButton';
import { TransitionPoint } from '../app-routing';
import { CharacterName } from "../game/vehicle/Character";
/* END-USER-IMPORTS */

export default class Title extends BaseScene {

  constructor() {
    super("Title");

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {

    // bg
    const bg = this.add.image(960, 384, "title", "bg-title.jpg");

    // batwing
    const batwing = this.add.image(1423, 231, "title", "character-batwing.png");

    // quiz
    const quiz = this.add.image(621, 136, "title", "character-quiz.png");

    // bam
    const bam = this.add.image(1218, 591, "title", "character-bam.png");

    // cash
    const cash = this.add.image(1220, 529, "title", "cash.png");

    // prank
    const prank = this.add.image(654, 578, "title", "character-prank.png");

    // jestah
    const jestah = this.add.image(1421, 576, "title", "character-jestah.png");

    // btnAudio
    const btnAudio = new BtnAudio(this, 1845, 73.5);
    this.add.existing(btnAudio);

    // btnPlay
    const btnPlay = new BtnPlay(this, 960, 615);
    this.add.existing(btnPlay);

    // title
    const title = this.add.image(960, 221, "title", "logo-batwheels.png");
    title.scaleX = 0.9;
    title.scaleY = 0.9;

    // subtitle
    const subtitle = this.add.image(960, 399, "title", "title-en.png");
    subtitle.scaleX = 1.1;
    subtitle.scaleY = 1.1;

    // btnAudio (components)
    const btnAudioUIPositionContainer = new UIPositionContainer(btnAudio);
    btnAudioUIPositionContainer.offsetX = 24;
    btnAudioUIPositionContainer.offsetY = 24;
    btnAudioUIPositionContainer.PinRight = true;
    btnAudioUIPositionContainer.PinTop = true;

    this.bg = bg;
    this.batwing = batwing;
    this.quiz = quiz;
    this.bam = bam;
    this.cash = cash;
    this.prank = prank;
    this.jestah = jestah;
    this.btnAudio = btnAudio;
    this.btnPlay = btnPlay;
    this.title = title;
    this.subtitle = subtitle;

    this.events.emit("scene-awake");
  }

  private bg!: Phaser.GameObjects.Image;
  private batwing!: Phaser.GameObjects.Image;
  private quiz!: Phaser.GameObjects.Image;
  private bam!: Phaser.GameObjects.Image;
  private cash!: Phaser.GameObjects.Image;
  private prank!: Phaser.GameObjects.Image;
  private jestah!: Phaser.GameObjects.Image;
  private btnAudio!: BtnAudio;
  private btnPlay!: BtnPlay;
  private title!: Phaser.GameObjects.Image;
  private subtitle!: Phaser.GameObjects.Image;

  /* START-USER-CODE */

  protected bamX:number = 0;
  protected bamY:number = 0;
  protected prankX:number = 0;
  protected prankY:number = 0;
  protected quizX:number = 0;
  protected quizY:number = 0;
  protected jestahX:number = 0;
  protected jestahY:number = 0;
  protected batwingX:number = 0;
  protected batwingY:number = 0;
  protected cashX:number = 0;
  protected cashY:number = 0;
  protected bgY:number = 0;



  public preload() {
    super.preload();

    // this.load.pack('asset-pack-title', assetPack as any);

    this.load.on(Phaser.Loader.Events.COMPLETE, this.postload, this);
  }

  public postload() {
    super.postload();

    console.log(this.cache);
    console.log(this.textures);
    // app.unload(this, assetPack);
  }

  public create() {
    super.create();
    this.editorCreate();

    this.bamX = this.bam.x;
    this.bamY = this.bam.y;
    this.prankX = this.prank.x;
    this.prankY = this.prank.y;
    this.batwingX = this.batwing.x;
    this.batwingY = this.batwing.y;
    this.jestahX = this.jestah.x;
    this.jestahY = this.jestah.y;
    this.quizX = this.quiz.x;
    this.quizY = this.quiz.y;
    this.cashX = this.cash.x;
    this.cashY = this.cash.y;
    this.bgY = this.bg.y;




    this.bam.x += 170;
    this.bam.y -= 30;
    this.bam.scale = 0.0;

    this.prank.x += 770;
    this.prank.y -= 10;
    this.prank.scale = 0.0;

    this.quiz.x += 770;
    this.quiz.y -= 20;
    this.quiz.scale = 0.0;

    this.jestah.x -= 10;
    this.jestah.y -= 5;
    this.jestah.scale = 0.0;

    this.batwing.x -= 100;
    this.batwing.y -= 40;
    this.batwing.scale = 0.0;

    this.cash.x -= 500;
    this.cash.y += 5;
    this.cash.scale = 0.0;



    this.bg.scale = 1.08;
    this.bg.y -=30;


    this.btnPlay.once(UIButton.events.clicked, () => {
      app.gotoNextScene(this, TransitionPoint.TitleEnd, { test: 'test' });
    });

    let localisedImage = app.localeHandler.getLocalisedImageFromId('title', { texture: this.subtitle.texture.key, frame: this.subtitle.frame.name });
    this.subtitle.setTexture(localisedImage.texture, localisedImage.frame);

    this.transitionInInit();
    //this.time.addEvent({ delay: 100, callback: this.transitionIn, callbackScope: this });
    this.transitionIn();
    // this.transitionOn();

    app.audioHandler.playSound(this, 'SndMusicLoop', 'music', {
      volume: 0.08,
      loop: true
    });
  }

  protected transitionInInit() {
    this.title.scale = 0.0;
    this.subtitle.scale = 0.0;
    this.btnPlay.y = 900;
  }

  protected transitionIn() {
    this.add.tween({
      targets: this.title,
      scaleX: 0.9,
      scaleY: 0.9,
      duration: 1000,
      delay:250,
      ease: Phaser.Math.Easing.Cubic.Out
    });

    this.add.tween({
      targets: this.subtitle,
      scaleX: 1.1,
      scaleY: 1.1,
      duration: 1250,
      delay:400,
      ease: Phaser.Math.Easing.Cubic.Out
    });

    this.add.tween({
      targets: this.btnPlay,
      y: 639,
      duration: 750,
      ease: Phaser.Math.Easing.Cubic.InOut
    });

    this.add.tween({
      targets: this.bg,
      scale: 1,
      duration: 1500,
      ease: Phaser.Math.Easing.Cubic.Out
    });

    this.add.tween({
      targets: this.bg,
      y: this.bgY,
      duration: 1500,
      ease: Phaser.Math.Easing.Cubic.Out
    });

    this.add.tween({
      targets: this.prank,
      x: this.prankX,
      y: this.prankY,
      scale: 1,
      duration: 1300,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: this.prankIdle,
      onCompleteScope: this
    });

    this.add.tween({
      targets: this.cash,
      x: this.cashX,
      y: this.cashY,
      scale: 1,
      duration: 900,
      delay:300,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: this.cashIdle,
      onCompleteScope: this
    });

    this.add.tween({
      targets: this.jestah,
      x: this.jestahX,
      y: this.jestahY,
      scale: 1,
      duration: 1300,
      delay:200,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: this.jestahIdle,
      onCompleteScope: this
    });

    this.add.tween({
      targets: this.quiz,
      x: this.quizX,
      y: this.quizY,
      scale: 1,
      duration: 1300,
      delay:300,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: this.quizIdle,
      onCompleteScope: this
    });

    this.add.tween({
      targets: this.bam,
      x: this.bamX,
      y: this.bamY,
      scale: 1,
      duration: 1800,
      delay:600,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: this.bamIdle,
      onCompleteScope: this
    });

    this.add.tween({
      targets: this.batwing,
      x: this.batwingX,
      y: this.batwingY,
      scale: 1,
      duration: 1700,
      delay:900,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: this.batwingIdle,
      onCompleteScope: this
    });

    this.time.addEvent({ delay: 1500, callback: this.startIdles, callbackScope: this });
  }

  protected prankIdle() {

    this.add.tween({
      targets: this.prank,
      scaleX: 1.003,
      scaleY: 1.003,
      y: this.prank.y - 0.7,
      duration: 200,
      ease: Phaser.Math.Easing.Cubic.InOut,
      loop: -1,
      yoyo: true
    });


  }

  protected cashIdle() {

    this.add.tween({
      targets: this.cash,
      scaleX: 0.98,
      scaleY: 0.98,
      y: this.cash.y - 1.8,
      duration: 1000,
      ease: Phaser.Math.Easing.Linear,
      loop: -1,
      yoyo: true
    });


  }

  protected jestahIdle() {

    this.add.tween({
      targets: this.jestah,
      scaleX: 1.003,
      scaleY: 1.003,
      y: this.jestah.y - 0.7,
      duration: 200,
      ease: Phaser.Math.Easing.Cubic.InOut,
      loop: -1,
      yoyo: true
    });


  }

  protected bamIdle() {

    this.add.tween({
      targets: this.bam,
      scaleX: 1.003,
      scaleY: 1.003,
      y: this.bam.y - 0.5,
      duration: 200,
      ease: Phaser.Math.Easing.Cubic.InOut,
      loop: -1,
      yoyo: true
    });
  }

  protected batwingIdle() {

    this.add.tween({
      targets: this.batwing,
      scaleX: 1.001,
      scaleY: 1.001,
      y: this.batwing.y - 2.5,
      duration: 1000,
      ease: Phaser.Math.Easing.Linear,
      loop: -1,
      yoyo: true
    });


  }

  protected quizIdle() {

    this.add.tween({
      targets: this.quiz,
      scaleX: 1.001,
      scaleY: 1.001,
      y: this.quiz.y - 3.5,
      duration: 1000,
      ease: Phaser.Math.Easing.Linear,
      loop: -1,
      yoyo: true
    });


  }



  protected startIdles() {
    this.add.tween({
      targets: this.subtitle,
      scaleX: 1.125,
      scaleY: 1.125,
      duration: 2000,
      ease: Phaser.Math.Easing.Cubic.InOut,
      loop: -1,
      yoyo: true
    });


  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
